var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.311688 7.83582L6.23377 13.6866C6.64935 14.1045 7.27273 14.1045 7.68831 13.6866C8.1039 13.2687 8.1039 12.6418 7.68831 12.2239L2.5974 7L7.68831 1.77612C8.1039 1.35821 8.1039 0.731343 7.68831 0.313433C7.48052 0.104477 7.27273 0 6.96104 0C6.64935 0 6.44156 0.104477 6.23377 0.313433L0.311688 6.16418C-0.103896 6.68657 -0.103896 7.31343 0.311688 7.83582C0.311688 7.73134 0.311688 7.73134 0.311688 7.83582Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.4713635445e97923c0137f5451705d5c.svg";
export { ForwardRef as ReactComponent };